// Field options for Lead editing dropdowns
// These values match the specification requirements

export interface FieldOption {
  value: string;
  label: string;
}

export const CONTACT_STATUS_OPTIONS: FieldOption[] = [
  { value: "not_contacted", label: "Not Contacted" },
  { value: "contacted_awaiting_response", label: "Contacted – Awaiting Response" },
  { value: "contacted_follow_up_scheduled", label: "Contacted – Follow-up Scheduled" },
  { value: "contacted_no_response", label: "Contacted – No Response" }
];

export const CALL_OUTCOME_OPTIONS: FieldOption[] = [
  { value: "connected_interested", label: "Connected – Interested" },
  { value: "connected_not_interested", label: "Connected – Not Interested" },
  { value: "call_disconnected", label: "Call Disconnected" },
  { value: "call_back_requested", label: "Call Back Requested" }
];

export const LEAD_QUALIFICATION_OPTIONS: FieldOption[] = [
  { value: "new_unqualified", label: "New / Unqualified" },
  { value: "qualified_follow_up", label: "Qualified – Needs Follow Up" },
  { value: "qualified_high_potential", label: "Qualified – High Potential" },
  { value: "warm_interested", label: "Warm Lead – Interested" },
  { value: "hot_ready_to_buy", label: "Hot Lead – Ready to Buy" },
  { value: "disqualified_not_fit", label: "Disqualified – Not a Fit" },
  { value: "disqualified_duplicate", label: "Disqualified – Duplicate" },
  { value: "disqualified_budget", label: "Disqualified – Budget Issues" },
  { value: "disqualified_competitor", label: "Disqualified – Competitor Chosen" }
];

// Helper function to get option label by value
export const getOptionLabel = (options: FieldOption[], value: string): string => {
  const option = options.find(opt => opt.value === value);
  return option ? option.label : value;
};

// All field options combined for easy access
export const FIELD_OPTIONS = {
  contactStatusOptions: CONTACT_STATUS_OPTIONS,
  callOutcomeOptions: CALL_OUTCOME_OPTIONS,
  leadQualificationOptions: LEAD_QUALIFICATION_OPTIONS
};
